// extracted by mini-css-extract-plugin
export default {"log":"UoMNcwi AQi6YMD"};